import request from '@/utils/request'
// 用户列表
export function user_list(params = {}) {
  return request({
    url: '/common/user_list',
    method: 'get',
    params
  })
}
// 绑定关系列表
export function material_bind_relations(params = {}) {
  return request({
    url: '/material_report/material_bind_relations',
    method: 'get',
    params
  })
}
// 绑定关系添加
export function addMaterial_bind_relations(data) {
  return request({
    url: '/material_report/material_bind_relations',
    method: 'post',
    data
  })
}
// 绑定关系修改
export function editMaterial_bind_relations(id, data) {
  return request({
    url: `material_report/material_bind_relations/${id}`,
    method: 'put',
    data
  })
}
// 组列表
export function listMaterial_bind_groups(params = {}) {
  return request({
    url: '/material_report/material_bind_groups',
    method: 'get',
    params
  })
}
// 组添加
export function addMaterial_bind_groups(data) {
  return request({
    url: '/material_report/material_bind_groups',
    method: 'post',
    data
  })
}
// 组修改
export function editMaterial_bind_groups(id, data) {
  return request({
    url: `material_report/material_bind_groups/${id}`,
    method: 'put',
    data
  })
}
// 报表列表
export function report_list(params = {}) {
  return request({
    url: '/material_report/report_list',
    method: 'get',
    params
  })
}
// 总计列表
export function total_report(params = {}) {
  return request({
    url: 'material_report/total_report',
    method: 'get',
    params
  })
}
// 修改消耗
export function set_cost(data) {
  return request({
    url: `material_report/set_cost`,
    method: 'put',
    data
  })
}
// 导出报表
export function export_report(data) {
  return request({
    url: 'material_report/export_report',
    method: 'post',
    data
  })
}
// 导出总计报表
export function export_report_total(data) {
  return request({
    url: 'material_report/export_report_total',
    method: 'post',
    data
  })
}
// /绑定关系修改状态
export function set_bind_status(data) {
  return request({
    url: `material_report/set_bind_status`,
    method: 'put',
    data
  })
}
// 总计列表
export function material_details(params = {}) {
  return request({
    url: 'material_report/material_details',
    method: 'get',
    params
  })
}
// 广告明细汇总
export function video_material_cost(params = {}) {
  return request({
    url: '/history_summary/video_material_cost',
    method: 'get',
    params
  })
}
